import { useMutation } from '@tanstack/react-query'

import { createPortalSession } from 'src/services/subscriptionApi'

export const useCreatePortalMutation = () => {
  return useMutation({
    mutationFn: createPortalSession,
  })
}
